import*as e from"react";const r=e.createContext({spawn:(a,n="info")=>{}});export{r as SnackbarContext};
//# sourceMappingURL=snackbar.js.map
